import React, { useState, useMemo } from "react";
import { Table, Group, Text, Box } from "@mantine/core";
// import { Avatar } from '@mantine/core';
import styles from "../../project-management/components/ProjectsTable/ProjectsTable.module.css";
import { useGetLeaves } from "api/leave/getLeave";
import { capitalizeFirstLetter } from "utils/capitalizeFirstLetter";

export default function LeaveRequestTable() {
  const { data, isLoading, error, refetch } = useGetLeaves();
  return (
    <Box
      style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "8px" }}
    >
      <div className={styles.container}>
        <Table
          withBorder
          className={styles.table}
          verticalSpacing="md"
          horizontalSpacing={20}
        >
          <thead>
            <tr>
              {/* <th className={styles["action-column"]}>EMPLOYEE ID</th> */}
              <th className={styles["name-column"]}>Employee Name</th>
              <th>Leave Type</th>
              <th>From</th>
              <th>TO</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Review Note</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.map((leaveRequestData, idx) => (
              <tr key={leaveRequestData._id}>
                {/* <td>
                  <Text>{leaveRequestData._id}</Text>
                </td> */}
                <td>
                  <Group spacing="xs">
                    <Text>
                      {leaveRequestData.user?.firstName}{" "}
                      {leaveRequestData.user?.lastName}
                    </Text>
                  </Group>
                </td>
                <td>
                  <Text>{leaveRequestData.leaveType}</Text>
                </td>
                <td>
                  <Text>
                    {new Date(leaveRequestData.fromDate).toLocaleDateString(
                      "en-US",
                      {
                        month: "long",
                        day: "numeric",
                        year: "numeric",
                      }
                    )}
                  </Text>
                </td>
                <td>
                  <Text>
                    {new Date(leaveRequestData.toDate).toLocaleDateString(
                      "en-US",
                      {
                        month: "long",
                        day: "numeric",
                        year: "numeric",
                      }
                    )}
                  </Text>
                </td>
                <td>
                  <Text>{leaveRequestData.reason}</Text>
                </td>
                <td>
                  <Text>{capitalizeFirstLetter(leaveRequestData.status)}</Text>
                </td>
                <td>
                  <Text>{leaveRequestData.reviewedByReason}</Text>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Box>
  );
}
